import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { UserProvider } from "./context/userContext";
import { CartProvider } from "./context/CartContext";
import { NotificationProvider } from "./context/notificationContext";
import { CheckoutProvider } from "./context/CheckoutContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <NotificationProvider>
        <UserProvider>
          <CartProvider>
            <CheckoutProvider>
              <App />
            </CheckoutProvider>
          </CartProvider>
        </UserProvider>
      </NotificationProvider>
    </BrowserRouter>
  </Provider>
);
